export default __webpack_public_path__ + "static/nancy-8ce987efcf88b349a274d6e17d2b545b.png";